import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const DigitosComprobanteArgentina = 8;
const DigitosComprobanteChile = 15;

const state = {
    id: 0,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    fechaVencimiento: moment(new Date()).format('YYYY-MM-DD'),
    periodo: moment(new Date()).format('YYYY-MM-DD'),
    periodoDia: 1,
    periodoMes: 0,
    periodoMesNombre: null,
    periodoAnio: 0,
    proveedorId: 0,
    proveedor: {},
    proveedorNombre: null,
    condicionFiscalId: 0,
    plazoPago: 0,
    // condicionFiscalNombre: null,
    comprobanteTipoId: 0,
    comprobanteTipo: {},
    comprobanteTipoNombre: null,
    formulario: '',
    numeroPuntoVenta: 0,
    numero: 0,
    monedaId: 0,
    moneda: {},
    monedaNombre: null,
    cotizacion: 1,
    total: 0,
    montoBase1: 0,
    pjeAlicuota1: 0,
    montoBase2: 0,
    pjeAlicuota2: 0,
    montoBase3: 0,
    pjeAlicuota3: 0,

    montoGravado: 0,
    montoExento: 0,
    montoNoGravado: 0,
    montoIvaInscripto: 0,
    montoIvaNoInscripto: 0,
    montoPercepcionIva: 0,
    montoPercepcionGanancias: 0,
    montoPercepcionComercioIndustria: 0,
    percepcionesProvinciales: [],
    montoPercepcionesProvinciales: 0,
    montoOtrosImpuestos: 0,
    amortizacionAnios: 0,
    observaciones: '',
    cancelaSaldo: false,

    ordenes: [], 
    renglones: [],
    renglonesRemitos: [],
    vendedoresComisiones: [],
    rowVersion: null,

    viaticoId: 0,

    ordenesProveedor: false,
    remitos: false,
    montoNetoRenglones: 0,
    
    montoOrdenesProveedores: 0,
    montoRemitos: 0,
    montoComisiones: 0,
    paginaActualComisiones: 1,
    registrosPorPaginaComisiones: 10,
    totalRegistrosComisiones: 0,
    totalPaginasComisiones: 1,

    cuentas: [],
    cuentasInfo: [],
    cuentaSelected: {},

    percepciones: [],
    percepcionesDatos: [],

    comprobantesTipos: [],
    comprobantesTiposList: [],
    formularios: [],

    formularioDisabled: false,
    numeroPuntoVentaDisabled: false,
    numeroDisabled: false,
    pjeAlicuotaDisabled: false,
    digitosNumeroComprobante: DigitosComprobanteArgentina,

    montoNoGravadoVisible: true,
    formularioVisible: true,
    puntoVentaVisible: true,
    montoPercepcionVisible: true,
    montoIvaNoInscriptoVisible: true,

    pjeIvaInscripto: 0,

    /* Referencia para creditos/debitos */
    compraId: 0,
    creditoParcial: false,

    paisId: 0
};

const mutations = {
    updateField,

    'INICIALIZAR_COMPRA' (state, params) {
        state.ordenesProveedor = params.ordenesProveedor;
        state.remitos = params.remitos;
        state.viaticoId = params.viaticoId || 0;

        let fecha = moment(new Date()).format('YYYY-MM-DD');

        state.id = params.compraId;
        state.fechaComprobante = fecha,
        state.fechaVencimiento = fecha,
        state.periodo = fecha,
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.proveedorId= 0;
        state.proveedor= null;
        state.proveedorNombre= null;
        state.condicionFiscalId= 0;
        state.plazoPago = 0;
        // state.condicionFiscal= null;
        // state.condicionFiscalNombre= null;
        state.comprobanteTipoId = 0;
        state.comprobanteTipo = null;
        state.comprobanteTipoNombre = null;
        state.formulario = '';
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.monedaId = 0;
        state.moneda = null;
        state.monedaNombre = null;
        state.cotizacion = 1;
        state.total = 0;
        state.montoBase1 = 0;
        state.pjeAlicuota1 = 0;
        state.montoBase2 = 0;
        state.pjeAlicuota2 = 0;
        state.montoBase3 = 0;
        state.pjeAlicuota3 = 0;
        state.montoGravado= 0;
        state.montoExento= 0;
        state.montoNoGravado= 0;
        state.montoIvaInscripto= 0;
        state.montoIvaNoInscripto= 0;
        state.montoPercepcionIva= 0;
        state.montoPercepcionGanancias= 0;
        state.montoPercepcionComercioIndustria = 0;
        state.percepcionesProvinciales= [];
        state.montoPercepcionesProvinciales= 0;
        state.montoOtrosImpuestos = 0;
        state.observaciones = '';
        state.amortizacionAnios = 0;
        state.ordenes = [];
        state.renglones = [];
        state.renglonesRemitos = [];
        state.vendedoresComisiones = [];
        state.cancelaSaldo = false;
        state.rowVersion = null;

        state.cuentas = [];
        state.cuentasInfo = [];

        /* Por defecto => pesos */
        state.monedaId = 101;
        state.moneda = {
            id: 101, 
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';

        state.montoNetoRenglones = 0;
        state.montoOrdenesProveedores = 0;
        state.montoRemitos = 0;
        state.montoComisiones = 0;
        state.paginaActualComisiones = 1;
        state.totalRegistrosComisiones = 0;

        state.paisId = params.paisId;

        state.comprobantesTipos = [];
        state.comprobantesTiposList = [];

        switch (state.paisId) {
            case 1: /* Argentina */
                state.pjeIvaInscripto = 21.0;
                state.montoNoGravadoVisible = true;
                state.formularioVisible = true;
                state.puntoVentaVisible = true;
                state.montoPercepcionVisible = true;
                state.montoIvaNoInscriptoVisible = true;
                state.formularios = ['A', 'B', 'C', 'M', 'X'];
        
                state.formularioDisabled = false;
                state.numeroPuntoVentaDisabled = false;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteArgentina;
                break;

            case 5: /* Chile */
                state.pjeIvaInscripto = 19.0;
                state.montoNoGravadoVisible = false;
                state.formularioVisible = false;
                state.puntoVentaVisible = false;
                state.montoPercepcionVisible = false;
                state.montoIvaNoInscriptoVisible = false;
                state.formularios = [];
        
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteChile;
                break;
        }

        state.compraId = 0;
        state.creditoParcial = false;

    },
    'SET_COMPROBANTES_TIPOS' (state, comprobantesTipos) {
        state.comprobantesTipos = comprobantesTipos;
        state.comprobantesTiposList = comprobantesTipos.map(comprobanteTipo => comprobanteTipo.nombre.trim());
    },
    'INICIALIZAR_CREDITO_DEBITO' (state, params) {
        state.compraId = params.compraId;
        state.creditoDebitoComprobantesTipos = [];
        state.creditoDebitoComprobantesTiposList = [];
        state.creditoParcial = params.creditoParcial;
    
        // state.ordenesProveedor = params.creditoParcial;
        state.ordenesProveedor = false;
        state.remitos = false;

        let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

        state.fechaComprobante = fecha,
        state.fechaVencimiento = fecha,
        state.periodo = fecha,
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.proveedorId= 0;
        state.proveedor= null;
        state.proveedorNombre= null;
        state.condicionFiscalId= 0;
        state.plazoPago = 0;
        // state.condicionFiscal= null;
        // state.condicionFiscalNombre= null;
        state.comprobanteTipoId = 0;
        state.comprobanteTipo = null;
        state.comprobanteTipoNombre = null;
        state.formulario = '';
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.monedaId = 0;
        state.moneda = null;
        state.monedaNombre = null;
        state.cotizacion = 1;
        state.total = 0;
        state.montoBase1 = 0;
        state.pjeAlicuota1 = 0;
        state.montoBase2 = 0;
        state.pjeAlicuota2 = 0;
        state.montoBase3 = 0;
        state.pjeAlicuota3 = 0;
        state.montoGravado= 0;
        state.montoExento= 0;
        state.montoNoGravado= 0;
        state.montoIvaInscripto= 0;
        state.montoIvaNoInscripto= 0;
        state.montoPercepcionIva= 0;
        state.montoPercepcionGanancias= 0;
        state.montoPercepcionComercioIndustria = 0;
        state.percepcionesProvinciales= [];
        state.montoPercepcionesProvinciales= 0;
        state.montoOtrosImpuestos = 0;
        state.observaciones = '';
        state.amortizacionAnios = 0;
        state.ordenes = [];
        state.renglones = [];
        state.renglonesRemitos = [];
        state.vendedoresComisiones = [];
        state.cancelaSaldo = false;
        state.rowVersion = null;

        state.cuentas = [];
        state.cuentasInfo = [];

        /* Por defecto => pesos */
        state.monedaId = 101;
        state.moneda = {
            id: 101, 
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';

        state.montoNetoRenglones = 0;
        state.montoOrdenesProveedores = 0;
        state.montoRemitos = 0;
        state.montoComisiones = 0;
        state.paginaActualComisiones = 1;
        state.totalRegistrosComisiones = 0;
        
        state.paisId = params.paisId;

        switch (state.paisId) {
            case 1: /* Argentina */
                state.pjeIvaInscripto = 21.0;
                state.montoNoGravadoVisible = true;
                state.formularioVisible = true;
                state.puntoVentaVisible = true;
                state.montoPercepcionVisible = true;
                state.montoIvaNoInscriptoVisible = true;
                state.formularios = ['A', 'B', 'C', 'M', 'X'];
        
                state.formularioDisabled = false;
                state.numeroPuntoVentaDisabled = false;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteArgentina;
                break;

            case 5: /* Chile */
                state.pjeIvaInscripto = 19.0;
                state.montoNoGravadoVisible = false;
                state.formularioVisible = false;
                state.puntoVentaVisible = false;
                state.montoPercepcionVisible = false;
                state.montoIvaNoInscriptoVisible = false;
                state.formularios = [];
        
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteChile;
                break;
        }
    },
    'SET_COMPRA' (state, compra) {
        state.fechaComprobante = moment(compra.fechaComprobante).format('YYYY-MM-DD'),
        state.fechaVencimiento = moment(compra.fechaVencimiento).format('YYYY-MM-DD'),
        state.periodo = moment(compra.periodo).format('YYYY-MM-DD')
        state.periodoMes= new Date(compra.periodo).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(compra.periodo).getFullYear();
        state.proveedorId = (compra.proveedor) ? compra.proveedor.id : 0;
        state.proveedor = compra.proveedor;
        state.proveedorNombre = compra.proveedor? compra.proveedor.nombre.trim() : null;
        state.condicionFiscalId= compra.condicionFiscal? compra.condicionFiscal.id : 0;
        state.plazoPago = compra.proveedor? compra.proveedor.formaPagoPlazo : 0;
        state.comprobanteTipoId = compra.comprobanteTipo ? compra.comprobanteTipo.id : 0;
        state.comprobanteTipo = compra.comprobanteTipo;
        state.comprobanteTipoNombre = compra.comprobanteTipo ? compra.comprobanteTipo.nombre.trim() : null;
        state.formulario = compra.formulario;
        state.numeroPuntoVenta = compra.numeroPuntoVenta;
        state.numero = compra.numero;
        state.monedaId = compra.moneda ? compra.moneda.id : 0;
        state.moneda = compra.moneda;
        state.monedaNombre = compra.moneda ? compra.moneda.nombre.trim() : null;
        state.cotizacion = compra.cotizacion;
        state.total = compra.total;
        state.montoBase1 = compra.montoBase1;
        state.pjeAlicuota1 = compra.pjeAlicuota1;
        state.montoBase2 = compra.montoBase2;
        state.pjeAlicuota2 = compra.pjeAlicuota2;
        state.montoBase3 = compra.montoBase3;
        state.pjeAlicuota3 = compra.pjeAlicuota3;
        state.montoGravado= compra.montoGravado;
        state.montoExento= compra.montoExento;
        state.montoNoGravado= compra.montoNoGravado;
        state.montoIvaInscripto= compra.montoIvaInscripto;
        state.montoIvaNoInscripto= compra.montoIvaNoInscripto;
        state.montoPercepcionIva= compra.montoPercepcionIva;
        state.montoPercepcionGanancias= compra.montoPercepcionGanancias;
        state.montoPercepcionComercioIndustria = compra.montoPercepcionComercioIndustria;
        state.percepcionesProvinciales= compra.percepcionesProvinciales;
        state.montoOtrosImpuestos = compra.montoOtrosImpuestos;
        state.observaciones = compra.observaciones;
        state.amortizacionAnios = compra.amortizacionAnios;
        state.rowVersion = compra.rowVersion;

        state.montoPercepcionesProvinciales= state.percepcionesProvinciales
            .reduce((importe, percepcion) => importe + percepcion.importe, 0);

        state.cuentas = compra.cuentas;
        setCuentasInfo(state);

        switch (state.paisId) {
            case 1: /* Argentina */
                state.formularioDisabled = false;
                state.numeroPuntoVentaDisabled = false;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteArgentina;

                switch (state.comprobanteTipoId) {
                    case 9: /* NoFiscal */
                    case 22: /* NoFiscalCredito */
                    case 24: /* FacturaExterior */
                        state.formularioDisabled = true;
                        state.numeroPuntoVentaDisabled = true;
                        state.numeroDisabled = false;
                        break;
                }
                break;
            
            case 5: /* Chile */
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                state.pjeAlicuotaDisabled = false;
                state.digitosNumeroComprobante = DigitosComprobanteChile;

                switch (state.comprobanteTipoId) {
                    case 17: /* Factura Exenta Electronica (Chile) */
                    case 18: /* Nota de Credito Exenta Electronica (Chile) */
                    case 19: /* Nota de Debito Exenta Electronica (Chile) */
                    case 21: /* Nota de Cobro (Chile) */
                        state.pjeAlicuotaDisabled = true;
                        break;
                }
                break;
        }
    },
    'SET_COMPRA_CREDITO_DEBITO'(state, compra) {
        let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

        state.fechaComprobante = fecha,
        // state.fechaVencimiento = fecha,
        state.periodo = fecha,
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.proveedorId = compra.proveedor? compra.proveedor.id : 0;
        state.proveedor = compra.proveedor;
        state.proveedorNombre = compra.proveedor? compra.proveedor.nombre.trim() : null;
        state.condicionFiscalId= compra.condicionFiscalId;
        state.plazoPago = compra.plazoPago || 0;
        state.comprobanteTipoId = compra.comprobanteTipo ? compra.comprobanteTipo.id : 0;
        state.comprobanteTipo = compra.comprobanteTipo;
        state.comprobanteTipoNombre = compra.comprobanteTipo ? compra.comprobanteTipo.nombre.trim() : null;

        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.plazoPago, 'days').format('YYYY-MM-DD');

        state.formulario = compra.formulario;
        state.numeroPuntoVenta = 0;
        state.numero = 0;
        state.monedaId = compra.moneda ? compra.moneda.id : 0;
        state.moneda = compra.moneda;
        state.monedaNombre = compra.moneda ? compra.moneda.nombre.trim() : null;
        state.cotizacion = compra.cotizacion;
        if (!state.creditoParcial) {
            state.total = compra.total;
            state.montoBase1 = compra.montoBase1;
            state.pjeAlicuota1 = compra.pjeAlicuota1;
            state.montoBase2 = compra.montoBase2;
            state.pjeAlicuota2 = compra.pjeAlicuota2;
            state.montoBase3 = compra.montoBase3;
            state.pjeAlicuota3 = compra.pjeAlicuota3;
            state.montoGravado= compra.montoGravado;
            state.montoExento= compra.montoExento;
            state.montoNoGravado= compra.montoNoGravado;
            state.montoIvaInscripto= compra.montoIvaInscripto;
            state.montoIvaNoInscripto= compra.montoIvaNoInscripto;
            state.montoPercepcionIva= compra.montoPercepcionIva;
            state.montoPercepcionGanancias= compra.montoPercepcionGanancias;
            state.montoPercepcionComercioIndustria = compra.montoPercepcionComercioIndustria;
            state.percepcionesProvinciales= compra.percepcionesProvinciales;
            state.montoOtrosImpuestos = compra.montoOtrosImpuestos;

            state.montoPercepcionesProvinciales= state.percepcionesProvinciales
                .reduce((importe, percepcion) => importe + percepcion.importe, 0);

            state.cuentas = compra.cuentas;
            setCuentasInfo(state);
        }

        state.amortizacionAnios = compra.amortizacionAnios;

        /* Asignamos el primer tipo de comprobante de la lista */
        if (state.comprobantesTipos) {
            if (state.comprobantesTipos.length != 0) {
                state.comprobanteTipo= state.comprobantesTipos[0];
                state.comprobanteTipoId= state.comprobanteTipo.id;
                state.comprobanteTipoNombre= state.comprobanteTipo.nombre.trim();
            }
        }

        /* Configuración del tipo de comprobante */
        if (state.comprobanteTipo) {
            state.formularioDisabled = !((/true/i).test(state.comprobanteTipo.requiereFormulario));

            if ((/true/i).test(state.comprobanteTipo.requierePuntoVenta)) {
                state.numeroPuntoVentaDisabled = false;
            } else {
                state.numeroPuntoVentaDisabled = true;

                if (state.comprobanteTipo.puntoVentaPredefinido != 0) {
                    state.numeroPuntoVenta = state.comprobanteTipo.puntoVentaPredefinido;
                }
            }
            state.pjeAlicuotaDisabled = state.comprobanteTipo.comprobanteExento;
        }

        if (state.creditoParcial) {
            state.renglones = [];

            if (compra.renglones) {
                /* Corresponde a una facturación de órdenes a proveedores */
                state.ordenesProveedor = true;

                compra.renglones.map(renglon => {
                    state.renglones.push({
                        id: renglon.ordenProveedorId,
                        fechaComprobante: renglon.fechaComprobante,
                        presupuesto: renglon.presupuesto,
                        importe: renglon.importe,
                        saldo: renglon.saldo,
                        importeFacturar: 0,
                        _rowVariant: ''
                    });
                });
            }

            state.renglonesRemitos = [];

            if (compra.remitos) {
                /* Corresponde a una facturación de remitos */
                state.remitos = true;

                state.renglonesRemitos = compra.remitos.map(compraRemito => ({
                    remitoId: compraRemito.remitoId,
                    fechaComprobante: compraRemito.fechaComprobante,
                    comprobante: compraRemito.comprobante,
                    destino: compraRemito.remitoDestino
                        + ((/true/i).test(compraRemito.presupuestoCerrado) ? ' (*)' : ''),
                    importe: compraRemito.importe,
                    saldo: compraRemito.saldo,
                    importeFacturar: 0,
                    // selected: false,
                    presupuestoCerrado: (/true/i).test(compraRemito.presupuestoCerrado),
                    _rowVariant: ''
                    })
                );
            }
        }
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedor = proveedor;
        state.proveedorId = proveedor? proveedor.id : 0;
        state.proveedorNombre = proveedor? proveedor.nombre.trim() : null;

        state.condicionFiscalId= proveedor? proveedor.condicionFiscalId : 0;
        state.plazoPago = proveedor? proveedor.formaPagoPlazo : 0;

        /* Actualizamos la fecha de vencimiento */
        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.plazoPago, 'days').format('YYYY-MM-DD');

        setFormulario(state);
        calcularMontos(state);
    },
    'CALCULAR_FECHA_VENCIMIENTO'(state) {
        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.plazoPago, 'days').format('YYYY-MM-DD');
    },
    'SET_COMPROBANTE_TIPO'(state, comprobanteTipo) {
        state.comprobanteTipoId = comprobanteTipo ? comprobanteTipo.id : 0;
        state.comprobanteTipo = comprobanteTipo;
        state.comprobanteTipoNombre = comprobanteTipo ? comprobanteTipo.nombre.trim() : null;

        if ((/true/i).test(state.comprobanteTipo.requiereFormulario)) {
            state.formularioDisabled = false;
            setFormulario(state);
        } else {
            state.formularioDisabled = true;
            state.formulario = state.comprobanteTipo.formularioPredefinido;
        }

        if ((/true/i).test(state.comprobanteTipo.requierePuntoVenta)) {
            state.numeroPuntoVentaDisabled = false;
        } else {
            state.numeroPuntoVentaDisabled = true;
            state.numeroPuntoVenta = state.comprobanteTipo.puntoVentaPredefinido;

            console.log(state.comprobanteTipo.puntoVentaPredefinido);
        }

        if ((/true/i).test(state.comprobanteTipo.comprobanteExento)) {
            state.pjeAlicuotaDisabled = true;
            state.pjeAlicuota1 = 0;
            state.pjeAlicuota2 = 0;
            state.pjeAlicuota3 = 0; 
        } else  {
            state.pjeAlicuotaDisabled = false;
        }

        calcularMontosTotal(state);

        calcularMontos(state);
    },
    'SET_MONEDA'(state, moneda) {
        let monedaId = 0;
        if (moneda) {
            if (moneda.id) {
                monedaId = parseInt(moneda.id);
            }
        }

        if (state.monedaId != monedaId) {
            state.monedaId = moneda ? moneda.id : 0;
            state.moneda = moneda;
            state.monedaNombre = moneda ? moneda.nombre.trim() : null;
            
            if ((/true/i).test(state.ordenesProveedor)) {
                state.renglones = [];
                state.montoGravado = 0;
                state.montoIvaInscripto = 0;
                state.montoNetoRenglones = 0;
                state.montoOrdenesProveedores = 0;
                state.montoRemitos = 0;
                state.montoComisiones = 0;
        
                state.ordenes.map(orden => {
                    state.renglones.push({
                        id: orden.id,
                        fechaComprobante: orden.fechaComprobante,
                        presupuesto: orden.presupuesto.trim()
                            + ((/true/i).test(orden.presupuestoCerrado) ? ' (*)' : ''),
                        moneda: orden.moneda,
                        importe: orden.importe,
                        saldo: orden.saldo,
                        importeFacturar: 0,
                        presupuestoCerrado: orden.presupuestoCerrado,
        
                        disabled: state.monedaId != orden.monedaId? true : false,
        
                        _rowVariant: ''
                    });
                });
            }

            if (state.vendedoresComisiones) {
                state.vendedoresComisiones.forEach(vendedorComision => {
                    vendedorComision.disabled = state.monedaId != vendedorComision.monedaId? true : false;
                });
            }
        }
    },
    'CALCULAR_MONTOS_TOTAL'(state) {
        if (state.ordenesProveedor || state.remitos) {
            state.montoBase1 = state.montoNetoRenglones;
            state.pjeAlicuota1 = parseFloat(21); 
            calcularMontos(state);
        } else {
            calcularMontosTotal(state);
        }
    },
    'CALCULAR_MONTOS'(state) {
        calcularMontos(state);
    },
    'SET_CUENTA' (state, compraCuenta) {
        if (state.cuentaSelected != null) {
            state.cuentaSelected.compraCuenta.cuentaId = compraCuenta.cuentaId;
            state.cuentaSelected.compraCuenta.cuenta = compraCuenta.cuenta
            state.cuentaSelected.compraCuenta.rubroId = compraCuenta.rubroId;
            state.cuentaSelected.compraCuenta.rubro = compraCuenta.rubro
            state.cuentaSelected.compraCuenta.subrubroId = compraCuenta.subrubroId;
            state.cuentaSelected.compraCuenta.subrubro = compraCuenta.subrubro
            state.cuentaSelected.compraCuenta.montoBase = compraCuenta.montoBase
            state.cuentaSelected.compraCuenta.montoImpuestos = compraCuenta.montoImpuestos
        } else { 
          state.cuentas.push(compraCuenta);
        }

        setCuentasInfo(state);

        /* Si estoy facturando renglones o remitos, sumo el monto base al monto base del comprobante */
        if ((/true/i).test(state.ordenesProveedor) || (/true/i).test(state.remitos)) {
            state.montoBase1 = parseFloat(state.montoNetoRenglones) + getImporteNetoCuentas(state.cuentas);
        }
    },
    'DELETE_CUENTA' (state) {
        var itemKey = -1
        for (let key in state.cuentas){
            const compraCuenta = state.cuentas[key]
            if ( compraCuenta == state.cuentaSelected.compraCuenta ){
                itemKey = key
            }
        }
        if (itemKey != -1) {
            state.cuentas.splice(itemKey, 1)      
        }
        
        setCuentasInfo(state);
    },
    'SET_ORDENES_PROVEEDOR' (state, ordenes) {
        state.ordenes = ordenes;
        state.renglones = [];
        state.montoGravado = 0;
        state.montoIvaInscripto = 0;
        state.montoNetoRenglones = 0;
        state.montoOrdenesProveedores = 0;

        state.ordenes.map(orden => {
            state.renglones.push({
                id: orden.id,
                fechaComprobante: orden.fechaComprobante,
                presupuesto: orden.presupuesto.trim()
                    + ((/true/i).test(orden.presupuestoCerrado) ? ' (*)' : ''),
                moneda: orden.moneda,
                importe: orden.importe,
                saldo: orden.saldo,
                importeFacturar: 0,
                presupuestoCerrado: orden.presupuestoCerrado,

                disabled: state.monedaId != orden.monedaId? true : false,

                _rowVariant: ''
            });
        });
    },
    'CALCULAR_TOTAL_ORDENES' (state) {
        /* Calculamos el total de ordenes seleccionadas */
        state.montoOrdenesProveedores = getImporteOrdenesProveedores(state.renglones);
        
        calcularTotalesRenglones(state);
        calcularMontos(state);
        validarOrdenes(state.renglones);
    },
    'SET_REMITOS_PROVEEDOR' (state, remitos) {
        state.montoGravado = 0;
        state.montoIvaInscripto = 0;
        state.montoNetoRenglones = 0;
        state.montoRemitos = 0;

        state.renglonesRemitos = remitos.map(remito => ({
            remitoId: remito.id,
            fechaComprobante: remito.fechaComprobante,
            comprobante: remito.comprobante,
            destino: remito.remitoDestino
                + ((/true/i).test(remito.presupuestoCerrado) ? ' (*)' : ''),
            importe: remito.importe,
            importeFacturar: remito.saldo,
            selected: false,
            presupuestoCerrado: (/true/i).test(remito.presupuestoCerrado),
            _rowVariant: ''
        }));
    },
    'CALCULAR_TOTAL_REMITOS' (state) {
        if (state.creditoParcial) {
            /* Calculamos el importe de los remitos seleccionados */
            state.montoRemitos = getImporteRemitosCredito(state.renglonesRemitos);
        } else {
            /* Calculamos el total de remitos seleccionados */
            state.montoRemitos = getImporteRemitos(state.renglonesRemitos);
        }

        /* Calculamos el monto neto (según la cotización) */
        state.montoNetoRenglones = state.montoRemitos;
        state.montoBase1 = state.montoNetoRenglones;
        state.pjeAlicuota1 = state.pjeIvaInscripto; 

        calcularMontos(state);

        if (state.creditoParcial) {
            validarRemitos(state.renglonesRemitos);
        }
    },
    'SET_PERCEPCIONES' (state, percepcionesProvinciales) {
        console.log(percepcionesProvinciales);
        
        state.percepcionesProvinciales= percepcionesProvinciales;

        state.montoPercepcionesProvinciales= state.percepcionesProvinciales
            .reduce((importe, percepcion) => importe + parseFloat(percepcion.importe), 0);
        
        calcularMontos(state);
    },
    'SET_COMISIONES' (state, comisiones) {
        state.vendedoresComisiones = comisiones
            .sort((a,b) => {
                var c = new Date(a.fechaVenta);
                var d = new Date(b.fechaVenta);
                return c-d;                
            })
            .map(vendedorComision => ({
                ...vendedorComision,
                importe: parseFloat(vendedorComision.montoComision),
                saldo: parseFloat(vendedorComision.saldoComision),
                importeFacturar: 0,
                disabled: state.monedaId != vendedorComision.monedaId? true : false,
                _rowVariant: ''
        }));

        state.paginaActualComisiones = 1;
        state.totalRegistrosComisiones = state.vendedoresComisiones.length;
    },
    'UPDATE_VENDEDOR_COMISION' (state, params) {
        let item = state.vendedoresComisiones
            .find(vendedorComision => vendedorComision.presupuestoInternoId == params.presupuestoInternoId
                && vendedorComision.vendedorId == params.vendedorId
                && vendedorComision.ventaId == params.ventaId);

        if (item) {
            item.saldo -= parseFloat(params.importe);

            if (item.saldo == 0) {
                state.vendedoresComisiones = state.vendedoresComisiones
                    .filter(vendedorComision => vendedorComision.saldo > 0);
            }
        }

        state.montoComisiones = getImporteComisiones(state.vendedoresComisiones);

        calcularTotalesRenglones(state);
        calcularMontos(state);
        validarComisiones(state.vendedoresComisiones);
    },
    'REMOVE_VENDEDOR_COMISION' (state, params) {
        const itemKey = state.vendedoresComisiones
            .findIndex(vendedorComision => vendedorComision.presupuestoInternoId == params.presupuestoInternoId
                && vendedorComision.vendedorId == params.vendedorId
                && vendedorComision.ventaId == params.ventaId);

        if (itemKey != -1) {
            state.vendedoresComisiones.splice(itemKey, 1);
        }

        state.montoComisiones = getImporteComisiones(state.vendedoresComisiones);

        calcularTotalesRenglones(state);
        calcularMontos(state);
        validarComisiones(state.vendedoresComisiones);
    },
    'CALCULAR_TOTAL_COMISIONES' (state) {
        state.montoComisiones = getImporteComisiones(state.vendedoresComisiones);

        calcularTotalesRenglones(state);
        calcularMontos(state);
        validarComisiones(state.vendedoresComisiones);
    },

    'SET_COMPRA_PARAMS' (state, compraParams) {
        state.fechaComprobante = moment(compraParams.fecha).format('YYYY-MM-DD');
        state.periodo = moment(compraParams.fecha).format('YYYY-MM-DD');
        state.periodoMes= new Date(compraParams.fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(compraParams.fecha).getFullYear();
        state.proveedorId = compraParams.proveedorId;
        state.proveedor = {
            id: compraParams.proveedorId,
            nombre: compraParams.proveedorDatos.nombreComercial,
        };
        state.proveedorNombre = compraParams.proveedorDatos.nombreComercial.trim();
        state.condicionFiscalId= compraParams.proveedorDatos.condicionFiscal.id;
        state.plazoPago = compraParams.proveedorDatos.formaPagoPlazo;
        state.numeroPuntoVenta = compraParams.numeroPuntoVenta;
        state.numero = compraParams.numero;

        state.fechaVencimiento = moment(state.fechaComprobante)
            .add(state.plazoPago, 'days').format('YYYY-MM-DD');

        let comprobanteTipo= {};

        switch (state.condicionFiscalId) {
            case 1:
            case 2:
                comprobanteTipo.id= 1;
                comprobanteTipo.nombre = 'FACTURA';
                if (state.condicionFiscalId == 1) {
                    state.formulario = 'A';
                } else {
                    state.formulario = 'C';
                }
                break;
        
            default:
                comprobanteTipo.id= 9;
                comprobanteTipo.nombre = 'NO FISCAL';
                state.formulario = 'X';
                state.numeroPuntoVenta = 1;
                state.formularioDisabled = true;
                state.numeroPuntoVentaDisabled = true;
                state.numeroDisabled = false;
                break;
        }

        state.comprobanteTipoId = comprobanteTipo.id;
        state.comprobanteTipo = comprobanteTipo;
        state.comprobanteTipoNombre = comprobanteTipo.nombre.trim();
        
        let moneda= {
            id: 101,
            nombre: 'PESOS'
        }
        state.monedaId = moneda.id;
        state.moneda = moneda;
        state.monedaNombre = moneda.nombre.trim();
        state.cotizacion = 1;
        state.total = compraParams.total;
        
        /* Calculamos monto base y alicuotas */ 
        calcularMontosTotal(state);

        /* Cuentas del proveedor */
        if (compraParams.proveedorDatos.cuentaId != 0) {
            state.cuentas = [];
            let compraCuenta = {
                cuentaId: compraParams.proveedorDatos.cuentaId,
                cuenta: compraParams.proveedorDatos.cuenta,
                rubroId: compraParams.proveedorDatos.rubroId,
                rubro: compraParams.proveedorDatos.rubro,
                subrubroId: compraParams.proveedorDatos.subrubroId,
                subrubro: compraParams.proveedorDatos.subrubro,
                montoBase: state.montoGravado + state.montoNoGravado + state.montoExento,
                montoImpuestos: state.montoIvaInscripto + state.montoIvaNoInscripto,
            }
            state.cuentas.push(compraCuenta);
        }
        setCuentasInfo(state);
    },
};

function setFormulario (state) {
    switch (state.paisId) {
        case 1: /* Argentina */
            switch (state.comprobanteTipoId) {
                case 1: /* Factura */
                case 2: /* Nota de credito */
                case 3: /* Nota de debito */   
                    switch (state.condicionFiscalId) {
                        case 0:
                            state.formulario = null;
                            break;
        
                        case 1:
                            state.formulario = 'A';
                            break;
                                
                        default:
                            /* RNI, Ex, Monot., No Categ., Cons. Final */
                            state.formulario = 'C';
                            break;
                    }
                    break;
                
                case 9: /* NoFiscal */
                case 22: /* NoFiscalCredito */
                case 24: /* FacturaExterior */
                    state.formulario = 'X';
                    break; 
        
                default:
                    state.formulario = null;
                    break;
            }
            break;
    
        case 5: /* Chile */
            state.formulario = '';
            break;
    }
}

function calcularTotalesRenglones(state) {
    let totalOrdenes = roundNumber(state.montoOrdenesProveedores * parseFloat(state.cotizacion), 2);
    let totalComisiones = roundNumber(state.montoComisiones * parseFloat(state.cotizacion), 2);
    
    /* Calculamos el monto neto (según la cotización) */
    state.montoNetoRenglones = roundNumber(totalOrdenes + totalComisiones, 2);
    state.montoBase1 = state.montoNetoRenglones;

    if (state.comprobanteTipo) {
        if ((/true/i).test(state.comprobanteTipo.comprobanteExento)) {
            state.pjeAlicuota1 = 0; 
            state.montoExento = state.montoNetoRenglones;
        } else {
            state.pjeAlicuota1 = state.pjeIvaInscripto; 
        }
    }
}

function calcularMontosTotal(state) {
    let total = 0;
    if (state.total != '') {
        if (!isNaN(state.total)) {
            total = parseFloat(state.total);
        }
    }
    
    /* Calculamos el total según la cotización del comprobante */
    if (state.monedaId != 101) {
        if (state.cotizacion != '') {
            if (!isNaN(state.cotizacion)) {
                total = roundNumber(parseFloat(state.cotizacion) * total, 2);
            }
        }
    }

    let pjeAlicuota2 = 0;
    if (state.pjeAlicuota2 != '') {
        if (!isNaN(state.pjeAlicuota2)) {
            pjeAlicuota2 = parseFloat(state.pjeAlicuota2);
        }
    }
    let pjeAlicuota3 = 0;
    if (state.pjeAlicuota3 != '') {
        if (!isNaN(state.pjeAlicuota3)) {
            pjeAlicuota3 = parseFloat(state.pjeAlicuota3);
        }
    }

    /* Por defecto al ingresar el total, calculamos el total con la alicuota del 21% */
    if (total != 0 ) {
        if (pjeAlicuota2 == 0 & pjeAlicuota3 == 0) {
            let pjeAlicuota = state.pjeIvaInscripto;
            let montoBase = 0;

            let comprobanteTipoId = 0;
            if (state.comprobanteTipo) {
                comprobanteTipoId = state.comprobanteTipo.id;
            }
            switch(comprobanteTipoId) {
                case 1: /* Factura */
                case 2: /* Nota de Credito */
                case 3: /* Nota de Debito */
                    if (state.formulario == 'A' || state.formulario == 'M') {
                        montoBase = roundNumber(total / (1 + pjeAlicuota / 100), 2);
                    } else {
                        montoBase = total;
                    }
                    break

                case 9: /* NoFiscal */
                case 22: /* NoFiscalCredito */
                case 24: /* FacturaExterior */
                    montoBase = total;
                    break
                
                case 14: /* Factura Electronica (Chile) */
                case 15: /* Nota de Credito Electronica (Chile) */
                case 16: /* Nota de Debito Electronica (Chile) */
                    montoBase = roundNumber(total / (1 + pjeAlicuota / 100), 2);
                    break;
                
                case 17: /* Factura Exenta Electronica (Chile) */
                case 18: /* Nota de Credito Exenta Electronica (Chile) */
                case 19: /* Nota de Debito Exenta Electronica (Chile) */
                case 21: /* Nota de Cobro (Chile) */
                    montoBase = 0;
                    pjeAlicuota = 0;
                    state.montoExento = total;
                    break;
        
                default:
                    montoBase = total;
                    break
            }

            state.montoBase1 = roundNumber(montoBase, 2);
            state.pjeAlicuota1 = pjeAlicuota;
        }
    } else {
        if (pjeAlicuota2 == 0 && pjeAlicuota3 == 0) {
            state.montoBase1 = 0;
            state.pjeAlicuota1 = 0;
        }
    }
    calcularMontos(state);
}

function calcularMontos(state) {    
    let montoGravado = 0
    let montoExento = 0
    let montoNoGravado = 0
    let montoIvaInscripto = 0
    let montoIvaNoInscripto = 0

    let montoBase1 = 0;
    if (state.montoBase1 != '') {
        if (!isNaN(state.montoBase1)) {
            montoBase1 = parseFloat(state.montoBase1);
        }
    }
    let montoBase2 = 0;
    if (state.montoBase2 != '') {
        if (!isNaN(state.montoBase2)) {
            montoBase2 = parseFloat(state.montoBase2);
        }
    }
    let montoBase3 = 0;
    if (state.montoBase3 != '') {
        if (!isNaN(state.montoBase3)) {
            montoBase3 = parseFloat(state.montoBase3);
        }
    }
    let pjeAlicuota1 = 0;
    if (state.pjeAlicuota1 != '') {
        if (!isNaN(state.pjeAlicuota1)) {
            pjeAlicuota1 = parseFloat(state.pjeAlicuota1);
        }
    }
    let pjeAlicuota2 = 0;
    if (state.pjeAlicuota2 != '') {
        if (!isNaN(state.pjeAlicuota2)) {
            pjeAlicuota2 = parseFloat(state.pjeAlicuota2);
        }
    }
    let pjeAlicuota3 = 0;
    if (state.pjeAlicuota3 != '') {
        if (!isNaN(state.pjeAlicuota3)) {
            pjeAlicuota3 = parseFloat(state.pjeAlicuota3);
        }
    }

    let comprobanteTipoId = 0;
    if (state.comprobanteTipo) {
        comprobanteTipoId = state.comprobanteTipo.id;
    }
    switch(comprobanteTipoId) {
        case 1: /* Factura */
        case 2: /* Nota de Credito */
        case 3: /* Nota de Debito */
            if (state.formulario == 'A' || state.formulario == 'M') {
                montoGravado = roundNumber(montoBase1, 2) 
                    + roundNumber(montoBase2, 2) 
                    + roundNumber(montoBase3, 2);
                montoIvaInscripto = roundNumber((montoBase1 * pjeAlicuota1 / 100), 2)
                    + roundNumber((montoBase2 * pjeAlicuota2 / 100), 2)
                    + roundNumber((montoBase3 * pjeAlicuota3 / 100), 2);
            } else if (state.formulario == 'B') {
                montoGravado = roundNumber(montoBase1, 2) 
                    + roundNumber(montoBase2, 2) 
                    + roundNumber(montoBase3, 2);
            } else if (state.formulario == 'C') {
                montoNoGravado = roundNumber(montoBase1, 2) 
                    + roundNumber(montoBase2, 2) 
                    + roundNumber(montoBase3, 2);
            }
            break

        case 9: /* NoFiscal (Argentina / Chile) */
        case 22: /* NoFiscalCredito (Argentina / Chile) */
        case 24: /* FacturaExterior (Argentina) */
            montoNoGravado = roundNumber(montoBase1, 2) 
                + roundNumber(montoBase2, 2) 
                + roundNumber(montoBase3, 2);
            break

        case 14: /* Factura Electronica (Chile) */
        case 15: /* Nota de Credito Electronica (Chile) */
        case 16: /* Nota de Debito Electronica (Chile) */
            montoGravado = roundNumber(montoBase1, 2) 
                + roundNumber(montoBase2, 2) 
                + roundNumber(montoBase3, 2);
            montoIvaInscripto = roundNumber((montoBase1 * pjeAlicuota1 / 100), 2)
                + roundNumber((montoBase2 * pjeAlicuota2 / 100), 2)
                + roundNumber((montoBase3 * pjeAlicuota3 / 100), 2);
            break;
        
        case 17: /* Factura Exenta Electronica (Chile) */
        case 18: /* Nota de Credito Exenta Electronica (Chile) */
        case 19: /* Nota de Debito Exenta Electronica (Chile) */
        case 21: /* Nota de Cobro (Chile) */
            montoGravado = 0;
            montoIvaInscripto = 0;
            break;

        default:
            montoNoGravado = roundNumber(montoBase1, 2) 
                + roundNumber(montoBase2, 2) 
                + roundNumber(montoBase3, 2);
            break
    }

    state.montoGravado = roundNumber(montoGravado, 2);
    // state.montoExento = roundNumber(montoExento, 2);
    state.montoNoGravado = roundNumber(montoNoGravado, 2);
    state.montoIvaInscripto = roundNumber(montoIvaInscripto, 2);
    state.montoIvaNoInscripto = roundNumber(montoIvaNoInscripto, 2);
}

function setCuentasInfo(state) {
    state.cuentasInfo = []

    state.cuentas.forEach(cuentaInfo => {
        let codigo = (cuentaInfo.cuenta ? cuentaInfo.cuenta.codigo : '')
            + (cuentaInfo.rubro ? cuentaInfo.rubro.codigo : '')
            + (cuentaInfo.subrubro ? cuentaInfo.subrubro.codigo : '');
        let nombre = (cuentaInfo.cuenta ? cuentaInfo.cuenta.nombre : '')
            + (cuentaInfo.rubro ? ' - ' + cuentaInfo.rubro.nombre : '')
            + (cuentaInfo.subrubro ? ' - ' + cuentaInfo.subrubro.nombre : '');

        state.cuentasInfo.push({
            compraCuenta: cuentaInfo,
            codigoCuenta: codigo,
            cuenta: nombre,
            montoBase: cuentaInfo.montoBase,
            montoImpuestos: cuentaInfo.montoImpuestos,
        });
    });
}

function getImporteNetoCuentas(cuentas) {
    let importeNeto = 0;
    importeNeto = cuentas
        .reduce((total, cuenta) => total + parseFloat(cuenta.montoBase), 0);
    return roundNumber(importeNeto, 2);
}

function getImporteOrdenesProveedores(renglones) {
    let importe = 0;
    importe = renglones
        .reduce((importeFacturar, orden) => {
            let importe = 0;
            if (orden.importeFacturar) {
                if (!isNaN(orden.importeFacturar)) {
                    importe = parseFloat(orden.importeFacturar);
                }
            }
            return importeFacturar + importe;
        }, 0);
    return importe;
    // return roundNumber(importeNeto * parseFloat(state.cotizacion), 2);
}

function getImporteRemitos(remitos) {
    let importe = 0;
    importe = remitos
        .reduce((importe, remito) => {
            return importe + ((/true/i).test(remito.selected) ? remito.importeFacturar : 0);
        }, 0);
    return roundNumber(importe, 2);
}

function getImporteRemitosCredito(renglones) {
    let importe = 0;
    importe = renglones
        .reduce((importeFacturar, remito) => {
            let importe = 0;
            if (remito.importeFacturar) {
                if (!isNaN(remito.importeFacturar)) {
                    importe = parseFloat(remito.importeFacturar);
                }
            }
            return importeFacturar + importe;
        }, 0);
    return importe;
}

function getImporteComisiones(comisiones) {
    let importe = 0;
    importe = comisiones
        .reduce((importeFacturar, comision) => {
            let importe = 0;
            if (comision.importeFacturar) {
                if (!isNaN(comision.importeFacturar)) {
                    importe = parseFloat(comision.importeFacturar);
                }
            }
            return importeFacturar + importe;
        }, 0);
    return roundNumber(importe, 2);
}

function validarOrdenes(renglones) {
    let ordenesValidas = true;

    renglones.forEach(renglon => {
        let saldo = renglon.saldo;
        let importeFacturar = 0;
        if (renglon.importeFacturar) {
            if (!isNaN(renglon.importeFacturar)) {
                importeFacturar = parseFloat(renglon.importeFacturar);
            }
        }
        
        /* Facturacion de ordenes a proveedores */
        if (importeFacturar < 0) {
            renglon._rowVariant = 'danger';
            ordenesValidas = false;
        } else if (saldo < importeFacturar) {
            renglon._rowVariant = 'danger';
            ordenesValidas = false;
        } else {
            renglon._rowVariant = '';
        }
    });
    return ordenesValidas;
}

function validarRemitos(remitos) {
    let remitosValidos = true;

    remitos.forEach(remito => {
        let saldo = remito.saldo;
        let importeFacturar = 0;
        if (remito.importeFacturar) {
            if (!isNaN(remito.importeFacturar)) {
                importeFacturar = parseFloat(remito.importeFacturar);
            }
        }
        
        /* Facturacion de ordenes a proveedores */
        if (importeFacturar < 0) {
            remito._rowVariant = 'danger';
            remitosValidos = false;
        } else if (saldo < importeFacturar) {
            remito._rowVariant = 'danger';
            remitosValidos = false;
        } else {
            remito._rowVariant = '';
        }
    });
    return remitosValidos;
}

function validarComisiones(comisiones) {
    let comisionesValidas = true;

    comisiones.forEach(comision => {
        let saldo = comision.saldo;
        let importeFacturar = 0;
        if (comision.importeFacturar) {
            if (!isNaN(comision.importeFacturar)) {
                importeFacturar = parseFloat(comision.importeFacturar);
            }
        }
        
        /* Facturacion de ordenes a proveedores */
        if (importeFacturar < 0) {
            comision._rowVariant = 'danger';
            ordenesValidas = false;
        } else if (saldo < importeFacturar) {
            comision._rowVariant = 'danger';
            comisionesValidas = false;
        } else {
            comision._rowVariant = '';
        }
    });
    return comisionesValidas;
}

const getters = {
    getField,
    getCuentasInfo (state) {
        return state.cuentasInfo;
    },
    getCuentaSelected (state) {
        return state.cuentaSelected;
    },
};

const actions = {
    inicializar ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;

            commit('INICIALIZAR_COMPRA', params);

            if (params.compraId != 0) {
                apiAxios.get('compras/comprobantes-tipos') 
                    .then(res => {
                        commit('SET_COMPROBANTES_TIPOS', res.data);

                        /* Recuperamos los datos de la compra */
                        return apiAxios.get(`compras/${params.compraId}/abm`)
                    })
                    .then(res => {
                        commit('SET_COMPRA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                /* Recuperamos el listado de tipos de comprobante */
                apiAxios.get('compras/comprobantes-tipos') 
                    .then(res => {
                        commit('SET_COMPROBANTES_TIPOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    inicializarCreditoDebito ( { commit, rootState }, params ) {
        return new Promise((resolve, reject) => {
            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;

            commit('INICIALIZAR_CREDITO_DEBITO', params);

            let queryString = '';
            if ((/true/i).test(params.creditoParcial)) {
                queryString = '?creditoParcial=true';
            }

            apiAxios.get(`compras/${params.compraId}/comprobantes-tipos` + queryString) 
                .then(res => {
                    commit('SET_COMPROBANTES_TIPOS', res.data);

                    /* Recuperamos los datos de la compra */
                    return apiAxios.get(`compras/${params.compraId}/credito-debito`)
                })
                .then(res => {
                    commit('SET_COMPRA_CREDITO_DEBITO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (parseFloat(state.montoGravado)
                    + parseFloat(state.montoNoGravado)
                    + parseFloat(state.montoExento)
                    + parseFloat(state.montoIvaInscripto)
                    + parseFloat(state.montoIvaNoInscripto)
                    + parseFloat(state.montoPercepcionIva)
                    + parseFloat(state.montoPercepcionGanancias)
                    + parseFloat(state.montoPercepcionComercioIndustria)
                    + parseFloat(state.montoPercepcionesProvinciales)
                    + parseFloat(state.montoOtrosImpuestos)  == 0) {
                save = false;
                errorMessage = "El importe total del comprobante no puede ser igual a cero."
            }

            if ((/true/i).test(state.ordenesProveedor)) {
                /* Actualizamos el total del comprobante */
                let totalPesos = parseFloat(state.montoGravado)
                    + parseFloat(state.montoNoGravado)
                    + parseFloat(state.montoExento)
                    + parseFloat(state.montoIvaInscripto)
                    + parseFloat(state.montoIvaNoInscripto)
                    + parseFloat(state.montoPercepcionIva)
                    + parseFloat(state.montoPercepcionGanancias)
                    + parseFloat(state.montoPercepcionComercioIndustria)
                    + parseFloat(state.montoPercepcionesProvinciales)
                    + parseFloat(state.montoOtrosImpuestos);
                
                /* Total según la cotización de la moneda */
                state.total = roundNumber(totalPesos / state.cotizacion, 2);

                /* Validamos las ordenes incluidas */
                if (!validarOrdenes(state.renglones)) {
                    save = false;
                    errorMessage = "Verifique el importe de los renglones incluidos en el comprobante."
                }

                /* Validamos las comisiones incluidas */
                if (!validarComisiones(state.vendedoresComisiones)) {
                    save = false;
                    errorMessage = "Verifique el importe de las comisiones facturadas en el comprobante."
                }
            }

            if ((/true/i).test(state.remitos)) {
                /* Actualizamos el total del comprobante */
                state.total = parseFloat(state.montoGravado)
                    + parseFloat(state.montoNoGravado)
                    + parseFloat(state.montoExento)
                    + parseFloat(state.montoIvaInscripto)
                    + parseFloat(state.montoIvaNoInscripto)
                    + parseFloat(state.montoPercepcionIva)
                    + parseFloat(state.montoPercepcionGanancias)
                    + parseFloat(state.montoPercepcionComercioIndustria)
                    + parseFloat(state.montoPercepcionesProvinciales)
                    + parseFloat(state.montoOtrosImpuestos);

                if (state.creditoParcial) {
                    /* Validamos los remitos incluidos */
                    if (!validarRemitos(state.renglonesRemitos)) {
                        save = false;
                        errorMessage = "Verifique el importe de los remitos incluidos en el comprobante."
                    }
                }
            }

            if (save) {
                let periodo = parseInt(state.periodoAnio).toString().trim()
                    + '-' + helpers.methods.getMesNumero(state.periodoMesNombre).toString().trim()
                    + '-01';
                
                let renglones;
                if (state.ordenesProveedor) {
                    renglones = [];
                    state.renglones.forEach(renglon => {
                        let importeFacturar = 0;
                        if (renglon.importeFacturar) {
                            if (!isNaN(renglon.importeFacturar)) {
                                importeFacturar = parseFloat(renglon.importeFacturar);
                            }
                        }
                        if (importeFacturar != 0) {
                            renglones.push({
                                ordenProveedorId: renglon.id,
                                importe: importeFacturar
                            });
                        }
                    });
                }

                let remitos;
                if (state.remitos) {
                    remitos = [];

                    if (state.creditoParcial) {
                        state.renglonesRemitos.forEach(remito => {
                            if (remito.importeFacturar != 0) {
                                remitos.push({
                                    remitoId: remito.remitoId,
                                    importe: remito.importeFacturar
                                })
                            }
                        });
                    } else {
                        state.renglonesRemitos.forEach(remito => {
                            if ((/true/i).test(remito.selected)) {
                                remitos.push({
                                    remitoId: remito.remitoId,
                                    importe: remito.importeFacturar
                                })
                            }
                        });
                    }
                }

                let percepcionesProvinciales = [];
                if (state.percepcionesProvinciales) {
                    percepcionesProvinciales = state.percepcionesProvinciales
                        .filter(percepcion => percepcion.importe != 0);
                }

                let presupuestosComisiones;
                if (state.vendedoresComisiones) {
                    presupuestosComisiones = [];
                    
                    state.vendedoresComisiones.forEach(comision => {
                        let importeFacturar = 0;
                        if (comision.importeFacturar) {
                            if (!isNaN(comision.importeFacturar)) {
                                importeFacturar = parseFloat(comision.importeFacturar);
                            }
                        }
                        if (importeFacturar != 0) {
                            presupuestosComisiones.push({
                                // presupuestoInternoId: comision.id,
                                presupuestoInternoId: comision.presupuestoInternoId,
                                ventaId: comision.ventaId,
                                vendedorId: comision.vendedorId,
                                importe: importeFacturar
                            })
                        }
                    });
                }

                let compra= {
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    fechaVencimiento: moment(state.fechaVencimiento).format('YYYY-MM-DD'),
                    periodo: periodo,
                    proveedorId: parseInt(state.proveedorId),
                    proveedor: state.proveedor,
                    comprobanteTipoId: parseInt(state.comprobanteTipoId),
                    comprobanteTipo: state.comprobanteTipo,
                    formulario: state.formulario.toUpperCase().trim(),
                    numeroPuntoVenta: parseInt(state.numeroPuntoVenta),
                    numero: parseInt(state.numero),
                    monedaId: parseInt(state.monedaId),
                    moneda: state.moneda,
                    cotizacion: parseFloat(state.cotizacion),
                    total: parseFloat(state.total),
                    montoBase1: parseFloat(state.montoBase1),
                    pjeAlicuota1: parseFloat(state.pjeAlicuota1),
                    montoBase2: parseFloat(state.montoBase2),
                    pjeAlicuota2: parseFloat(state.pjeAlicuota2),
                    montoBase3: parseFloat(state.montoBase3),
                    pjeAlicuota3: parseFloat(state.pjeAlicuota3),
                    montoGravado: parseFloat(state.montoGravado),
                    montoExento: parseFloat(state.montoExento),
                    montoNoGravado: parseFloat(state.montoNoGravado),
                    montoIvaInscripto: parseFloat(state.montoIvaInscripto),
                    montoIvaNoInscripto: parseFloat(state.montoIvaNoInscripto),
                    montoPercepcionIva: parseFloat(state.montoPercepcionIva),
                    montoPercepcionGanancias: parseFloat(state.montoPercepcionGanancias),
                    montoPercepcionComercioIndustria: parseFloat(state.montoPercepcionComercioIndustria),
                    percepcionesProvinciales: percepcionesProvinciales,
                    montoOtrosImpuestos: parseFloat(state.montoOtrosImpuestos),
                    amortizacionAnios: parseInt(state.amortizacionAnios),
                    observaciones: state.observaciones.trim(),

                    cuentas: state.cuentas,
                    renglones,
                    remitos,
                    presupuestosComisiones,
                    viaticoId: state.viaticoId,
                    cancelaSaldo: (/true/i).test(state.cancelaSaldo)
                };

                let url = 'compras';
                if (state.id != 0) {
                    url += '/' + state.id;
                    compra.rowVersion = state.rowVersion;
                }

                if (state.compraId != 0) {
                    compra.compraReferenciaId = state.compraId;
                    compra.creditoParcial = state.creditoParcial;
                }

                apiAxios.post(url, compra)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

   setProveedor: ({ commit, state }, proveedor) => {
        return new Promise((resolve, reject) => {
            commit('SET_PROVEEDOR', proveedor);

            if (state.ordenesProveedor && proveedor) {
                /* Recuperamos las ordenes con saldo del proveedor */
                let queryString = '?proveedorId=' + proveedor.id;

                apiAxios.get('ordenesproveedores/facturacion' + queryString ) 
                    .then(res => {
                        commit('SET_ORDENES_PROVEEDOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else if (state.remitos && proveedor) {
                /* Recuperamos los remitos */
                let queryString = '?transporteId='+ proveedor.id
                    + '&facturacion=true';

                apiAxios.get('remitos/facturar' + queryString)
                    .then(res => {
                        commit('SET_REMITOS_PROVEEDOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else if (proveedor) {
                /* Recuperamos las comisiones con saldo del proveedor */
                let queryString = '?proveedorId=' + proveedor.id;

                apiAxios.get('vendedores/facturacion' + queryString ) 
                    .then(res => {
                        commit('SET_COMISIONES', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                        
            } else {
                resolve();
            }

        })
    },
    setComprobanteTipo: ({commit}, comprobanteTipo) => {
        commit('SET_COMPROBANTE_TIPO', comprobanteTipo);
    },
    setMoneda: ({commit}, moneda) => {
        commit('SET_MONEDA', moneda);
    },
    calcularMontosTotal: ({ commit }) => {
        commit('CALCULAR_MONTOS_TOTAL');
    },
    calcularMontos: ({ commit }) => {
        // console.log('calcularMontos');
        commit('CALCULAR_MONTOS');
    },
    setCuenta: ({commit}, compraCuenta) => {
        commit('SET_CUENTA', compraCuenta);
    },
    deleteCuenta: ({commit}) => {
        /* Eliminamos la cuenta seleccionada */
        commit('DELETE_CUENTA');
    },
    calcularTotalOrdenes: ({ commit }) => {
        commit('CALCULAR_TOTAL_ORDENES');
    },
    calcularTotalRemitos: ({ commit }) => {
        commit('CALCULAR_TOTAL_REMITOS');
    },
    setPercepciones: ({commit}, percepciones) => {
        commit('SET_PERCEPCIONES', percepciones);
    },
    calcularTotalComisiones: ({ commit }) => {
        commit('CALCULAR_TOTAL_COMISIONES');
    },
    updateVendedorComision: ({ commit }, params) => {
        commit('UPDATE_VENDEDOR_COMISION', params);
    },
    removeVendedorComision: ({ commit }, params) => {
        commit('REMOVE_VENDEDOR_COMISION', params);
    },
    calcularFechaVencimiento: ( { commit }) => {
        commit('CALCULAR_FECHA_VENCIMIENTO');
    },

    setCompraParametros: ({ commit, rootState }, compraParams) => {
        return new Promise((resolve, reject) => {
            let params = {
                compraId: 0,
                ordenesProveedor: false,
                viaticoId: compraParams.viaticoId
            }

            let paisId = 0;
            if (rootState.user) {
                if (rootState.user.empresa) {
                    if (rootState.user.empresa.paisId) {
                        paisId = rootState.user.empresa.paisId;
                    }
                }
            }
            params.paisId = paisId;
  
            commit('INICIALIZAR_COMPRA', params);

            apiAxios.get('compras/comprobantes-tipos') 
                .then(res => {
                    commit('SET_COMPROBANTES_TIPOS', res.data);
                    /* Recuperamos los datos del proveedor */
                    return apiAxios.get(`proveedores/${compraParams.proveedorId}/facturacion`)
                })
                .then(res => {
                    compraParams.proveedorDatos = res.data;
                    commit('SET_COMPRA_PARAMS', compraParams);

                    // resolve();
                    /* Recuperamos las comisiones del vendedor asociado */
                    let queryString = '?proveedorId=' + compraParams.proveedorId;

                    return apiAxios.get('vendedores/facturacion' + queryString ) 
                })
                .then(res => {
                    commit('SET_COMISIONES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}